import React, { useState } from 'react'
import { Input, Button, Form, Select, DatePicker, message } from 'antd'
import dayjs from 'dayjs'
import axios from 'axios';
import { MemberRegistration } from '../AllApi/UserApi/UserApi';

const { Option } = Select

const RegisterForm = ({ form, closeModal }) => {

  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [genderSelected, setGenderSelected] = useState('')
  const [dob, setDob] = useState(null)

  const [isFormValid, setIsFormValid] = useState(false);
  // const [form] = Form.useForm();


   const isAgeValid = () => {
    if (!dob || !genderSelected) return true

    const today = dayjs()
    const birthDate = dayjs(dob)
    const age = today.diff(birthDate, 'year')

    return genderSelected === '1' ? age >= 21 : age >= 18
  }

  const onFinish = async (values) => {
  if (!isAgeValid()) {
    alert("Age criteria not met.");
    return;
  }

 const reg_data = {
    fname: values.FirstName,
    mname: values.MiddleName,
    lname: values.LastName,
    mob_no: values.Mobile,
    email: values["Email Id"],  // Because key has a space
    password: values.Password,
    gender: genderSelected,
    dateofbirth: dob ? dayjs(dob).format("YYYY-MM-DD") : null,
  };

  console.log('Register:', reg_data);

  // Call your register API here
  await handleRegisterMember(reg_data);
  }

    const handleRegisterMember = async (data) => {
      setLoading(true);
      try {
        const response = await axios.post(MemberRegistration,data);
         if (response.data === "SAVED") {
            messageApi.success('Registration successful!');
            form.resetFields();          // ✅ Clear form fields
            setDob(null);                // ✅ Clear DOB
            setGenderSelected("");       // ✅ Clear gender
            closeModal();  
         }
          else if (response.data === "ALREADYEXIST") {
              setLoading(false);
               messageApi.warning('Member already exist! Please try with different email or mobile ');
          }
      } catch (error) {
        messageApi.error('API call failed!');
        console.error('API Error:', error);
      } finally {
        setLoading(false);
      }
    };


    const handleFormChange = () => {
      const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
      const allTouched = form.isFieldsTouched(true);
      setIsFormValid(!hasErrors && allTouched);
    };


  return (
    <Form layout="vertical" form={form} onFinish={onFinish} onFieldsChange={handleFormChange}>

    {contextHolder}

      
      <div className='row p-0 m-0'>

        {/* Candidate Name Fields */}
        <div className='col-12 col-lg-4'>
          <Form.Item
              name="FirstName"
              label="Candidate's First Name"
              rules={[{ required: true, pattern: /^[a-zA-Z\s]*$/, message: 'Only alphabets allowed' }]}
            >
              <Input />
            </Form.Item>
        </div>

        <div className='col-12 col-lg-4'>
            <Form.Item
              name="MiddleName"
              label="Candidate's Middle Name"
              rules={[{ required: true, pattern: /^[a-zA-Z\s]*$/, message: 'Only alphabets allowed' }]}
            >
              <Input />
            </Form.Item>
        </div>

        <div className='col-12 col-lg-4'>
            <Form.Item
              name="LastName"
              label="Candidate's Last Name"
              rules={[{ required: true, pattern: /^[a-zA-Z\s]*$/, message: 'Only alphabets allowed' }]}
            >
              <Input />
            </Form.Item>
        </div>


        {/* Gender */}
        <div className='col-12 col-lg-4'>
          <Form.Item
            name="Gender"
            label="Gender"
            rules={[{ required: true, message: 'Please select gender' }]}
          >
            <Select
              placeholder="Select Gender"
              onChange={(value) => setGenderSelected(value)}
            >
              <Option value="1">Male</Option>
              <Option value="2">Female</Option>
            </Select>
          </Form.Item>
        </div>

        {/* Date of Birth */}
        <div className="col-12 col-lg-4">
            <Form.Item label="Date of Birth" required>
                <DatePicker
                  style={{ width: '100%' }}
                  format="DD-MM-YYYY"
                  value={dob}
                  onChange={(date) => setDob(date)}
                  open={genderSelected ? undefined : false} // prevent open when gender is not selected
                  onOpenChange={(open) => {
                    if (open && !genderSelected) {
                      alert('Please select gender first.')
                    }
                  }}
                />
                {genderSelected && !isAgeValid() && (
                  <div style={{ color: 'red' }}>
                    Age criteria not met. (Male: 21+ years, Female: 18+ years)
                  </div>
                )}
              </Form.Item>
        </div>

        <div className="col-12 col-lg-4">
            <Form.Item name="Email Id" label="Email" rules={[{ required: true, type: 'email' }]}>
              <Input />
            </Form.Item>
        </div>

        <div className="col-12 col-lg-4">
           <Form.Item
                name="Mobile"
                label="Mobile No."
                rules={[
                  { required: true, message: 'Please enter your mobile number' },
                  {
                    pattern: /^\d{10}$/,
                    message: 'Mobile number must be exactly 10 digits',
                  },
                ]}
              >
                <Input
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault()
                    }
                  }}
                />
              </Form.Item>
        </div>

        <div className="col-12 col-lg-4">
           <Form.Item
              name="Password"
              label="Password"
              rules={[{ required: true, message: 'Please enter password' }]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>
        </div>

        <div className="col-12 col-lg-4">
           <Form.Item
                name="ConfirmPassword"
                label="Confirm Password"
                dependencies={['Password']}
                hasFeedback
                rules={[
                  { required: true, message: 'Please confirm your password' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('Password') === value) {
                        return Promise.resolve()
                      }
                      return Promise.reject(new Error('Passwords do not match!'))
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
        </div>

        {/* Register Btn */}
        <div className="row p-0 m-0">
            <div className="col-12 col-lg-3"></div>
            <div className="col-12 col-lg-6">
              <Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading} block  className='registerBtn shadow'  disabled={!isFormValid}>
                    REGISTER
                  </Button>
                </Form.Item>
            </div>
            <div className="col-12 col-lg-3"></div>
        </div>

      </div>
      

    </Form>
  )
}

export default RegisterForm
